const Projects = () => <h1>Listado de proyectos pronto ...</h1>;

export default Projects;
